
















































































































































import Vue from 'vue';
import Fleet from '@/classes/fleet/fleet';
import { ContactRate } from '@/classes/interfaces/contactRate';
import DoughnutChart, { DoughnutGraphData, DoughnutGraphOption, LabelCallbackArg } from '@/components/graph/Doughnut.vue';
import EnemyFleet from '@/classes/enemy/enemyFleet';
import Airbase from '@/classes/airbase/airbase';

const contactGraphLabels = ['×1.2', '×1.17', '×1.12', 'No Contact'];
const contactGraphColors = ['rgba(100, 180, 255, 0.7)', 'rgba(80, 220, 120, 0.7)', 'rgba(255, 160, 100, 0.7)', 'rgba(128, 128, 128, 0.5)'];
const labelCallback = (c: LabelCallbackArg) => `${c.dataset.labels[c.dataIndex]}: ${c.parsed.toFixed(1)} %`;

export default Vue.extend({
  name: 'ContactRates',
  components: { DoughnutChart },
  props: {
    fleet: {
      type: [Fleet, EnemyFleet, Airbase],
      required: true,
    },
  },
  data: () => ({
    airState: 0,
    airStatus: ['AS+', 'AS', 'AD'],
    graphData: {},
    unionGraphData: {},
    rates: [] as ContactRate[],
    unionRates: [] as ContactRate[],
    options: {
      plugins: {
        legend: { display: false },
        title: { display: true, text: '' },
        tooltip: { callbacks: { label: labelCallback } },
        datalabels: { formatter: (v: number) => (v > 0 ? `${v.toFixed(1)}%` : '') },
      },
    } as DoughnutGraphOption,
    unionOptions: {
      plugins: {
        legend: { display: false },
        title: { display: true, text: '' },
        tooltip: { callbacks: { label: labelCallback } },
        datalabels: { formatter: (v: number) => (v > 0 ? `${v.toFixed(1)}%` : '') },
      },
    } as DoughnutGraphOption,
    graphLegends: [] as { text: string; color: string }[],
  }),
  created() {
    // 初期化はお早めに
    this.calculate();
  },
  methods: {
    calculate() {
      this.rates = this.fleet.getContactRates();
      this.unionRates = this.fleet.getContactRates(true);

      this.graphData = this.getGraphData(this.rates[this.airState]);
      this.unionGraphData = this.getGraphData(this.unionRates[this.airState]);

      this.graphLegends = [];
      for (let i = 0; i < 4; i += 1) {
        this.graphLegends.push({ text: contactGraphLabels[i], color: contactGraphColors[i] });
      }
    },
    changeAirState(): void {
      this.graphData = this.getGraphData(this.rates[this.airState]);
      this.unionGraphData = this.getGraphData(this.unionRates[this.airState]);
    },
    getGraphData(rate: ContactRate): DoughnutGraphData {
      const data = {
        labels: contactGraphLabels,
        datasets: [
          {
            data: [0, 0, 0, 100],
            backgroundColor: contactGraphColors,
            borderColor: '#fff',
            labels: contactGraphLabels,
          },
        ],
      };
      if (rate) {
        data.datasets[0].data = [rate.contact120, rate.contact117, rate.contact112, 100 - rate.sumRate];
      }
      return data;
    },
  },
});
